// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// global styles
import "./src/styles/global.css"

// prism theme for syntax highlighting
import "prismjs/themes/prism-tomorrow.css"
